/*
 * Las flechas de una tira que desliza (bloque natnatura-rejilla en modo
 * carrusel y natnatura-voces). La tira ya funciona sin esto: es `scroll-snap`
 * sobre el propio contenedor y se arrastra, se rueda y se recorre con el
 * teclado. Este script solo hace que las dos flechas muevan la tira UNA PIEZA
 * y se apaguen en los extremos.
 *
 * Marcado que espera, en cualquier orden dentro del mismo padre:
 *
 *   <div data-nn-tira-mandos>
 *     <button data-nn-tira-prev>…</button>
 *     <button data-nn-tira-next>…</button>
 *   </div>
 *   <div data-nn-tira> …piezas… </div>
 *
 * Se mide la primera pieza para saber cuanto desplazar: asi vale para una
 * tira de cuatro columnas y para una de tres sin que nadie escriba anchos
 * aqui. La animacion la pone `scroll-behavior: smooth` en CSS, que respeta
 * `prefers-reduced-motion` desde la propia hoja.
 */
(() => {
  const arranca = (mandos) => {
    if (mandos.hasAttribute('data-nn-tira-lista')) return;
    const padre = mandos.parentElement;
    const tira = padre && padre.querySelector(':scope > [data-nn-tira]');
    const prev = mandos.querySelector('[data-nn-tira-prev]');
    const next = mandos.querySelector('[data-nn-tira-next]');
    if (!tira || !prev || !next) return;
    mandos.setAttribute('data-nn-tira-lista', '');

    const paso = () => {
      const pieza = tira.firstElementChild;
      if (!pieza) return tira.clientWidth;
      const hueco = parseFloat(getComputedStyle(tira).columnGap) || 0;
      return pieza.getBoundingClientRect().width + hueco;
    };

    const estado = () => {
      const tope = tira.scrollWidth - tira.clientWidth;
      prev.disabled = tira.scrollLeft <= 1;
      next.disabled = tira.scrollLeft >= tope - 1;
      // Sin nada que desplazar, las dos quedan apagadas pero a la vista:
      // Fran (18/09) las quiere en todas las tiras, tambien en «Nuestra
      // comunidad», que hoy trae cuatro videos en cuatro columnas; y el
      // Figma las pinta en tinta plena aunque no haya hacia donde ir.
      mandos.hidden = false;
    };

    prev.addEventListener('click', () => tira.scrollBy({ left: -paso() }));
    next.addEventListener('click', () => tira.scrollBy({ left: paso() }));
    tira.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado, { passive: true });
    estado();
  };

  const todo = () => document.querySelectorAll('[data-nn-tira-mandos]').forEach(arranca);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todo);
  } else {
    todo();
  }
  // El editor de temas vuelve a pintar la seccion al tocar un ajuste.
  document.addEventListener('shopify:section:load', todo);
})();
